// extracted by mini-css-extract-plugin
export default {"modal":"SignupDetails_modal__qQwAc","signupDetailsMain":"SignupDetails_signupDetailsMain__+LqdG","signupDetailsBody":"SignupDetails_signupDetailsBody__h5wer"};